import React, {
  useRef,
  useEffect,
  useState,
  useCallback,
  forwardRef,
  useImperativeHandle,
} from "react";
import SearchPanel from "../../../../../widgets/SearchPanel";
import { fnGetDataSet, fnSave } from "@shared/api/restApi";
import { getInitFormData } from "@shared/utils/CommonUtils";
import { global } from "@shared/libs/Global";
import SharedForm from "../../../../../widgets/SharedForm";
import SnAgTree from "@shared/components/Grid/SnTree";
import { menuInfo } from "@shared/type/CommonType";
import { showDialog } from "@widgets/CommonDialog";
import SnButton from "@shared/components/SnButton";
import SnResizable from "@shared/components/SnResizable";
import usePanelSizes from "@shared/hooks/usePanelSizes";
interface Props {
  Menuprops: menuInfo;
}

interface RowData {
  KeyField?: string;
  [key: string]: any;
}

const SN_SYS_BAS_REG_001 = forwardRef(({ Menuprops }: Props, ref) => {
  //#region  variable
  const treeGridApiRef = useRef<any>(null);
  const searchRef = useRef<any>(null);
  const { userInfo } = global();

  const treeRef = useRef<any>(null); // Replace with the actual ref target
  const [isExpanded, setIsExpanded] = useState(false);
  const [expandBtnText, setExpandBtnText] = useState("Expand");
  //#endregion

  //#region  Components useState
  const [formData, setFormData] = useState<any>();
  const [formControlData, setFormControlData] = useState<any[]>([]);
  const [columns, setColums] = useState<any[]>([]);
  const [sharedForm, setSharedForm] = useState<any[]>([]);
  const [dataSource1, setDataSource1] = useState<any>();
  const SharedFormref1 = useRef<any>();
  const [focusedRowData, setFocusedRowData] = useState<any>();
  const [isLoading, setIsLoading] = useState(false);
  const [gridFocus, setGridFocus] = useState(false);
  //#endregion

  //#region grid 길이 관련
  const cd_menu = Menuprops.cd_menu || "SN_SYS_BAS_REG_001";
  const defaultSize = { panel1: "49.5%", panel2: "49.5%" };
  const [sizes, onResizeStop] = usePanelSizes(cd_menu, defaultSize);
  const [autogroupDef, setAutogroupDef] = useState<any>({
    headerName: "메뉴명", // 그룹 컬럼의 헤더 이름
    field: "nm_menu", // 데이터를 표시할 필드
    flex: 1,
    filter: "agTextColumnFilter",
    cellClass: "large-cell", // add custom class
    cellRendererParams: {
      suppressCount: true,
      suppressDoubleClickExpand: true,
      suppressHoverHighlight: false,
      innerRenderer: (params: any) => {
        const { value, node } = params;

        let icon = "";
        if (node.data.fg_menu === "MGM" || node.data.fg_menu === "") {
          icon = node.expanded ? "📂" : "📁";
        } else if (node.data.fg_menu === "REG") {
          icon = "📝";
        } else if (node.data.fg_menu === "REP") {
          icon = "📄";
        }

        return `${icon} ${value}`;
      },
    },
    cellRenderer: "agGroupCellRenderer",
  });
  //#endregion

  useEffect(() => {
    const fetchform = async () => {
      //setDataSource1([]);
      try {
        const rtn: any = await getInitFormData();
        const hidecolumns = rtn.grid.grid1.map((column: any) => {
          if (column.field !== "nm_menu") {
            return {
              ...column,
              hide: true,
            };
          }
          return column;
        });
        setFormData(rtn.formData);
        setFormControlData(rtn.formControlData);
        setSharedForm(rtn.form.freeform1);
        setColums(hidecolumns);
      } catch (error) {}
    };
    fetchform();
  }, []);

  useEffect(() => {
    if (gridFocus && treeGridApiRef.current?.api) {
      setTimeout(() => {
        const api = treeGridApiRef.current.api;
        const row = api.getDisplayedRowAtIndex(0);
        if (row) {
          // api.ensureIndexVisible(0);
          api.setFocusedCell(0, "cd_menu");
          // row.setSelected(true);
        }
        setGridFocus(false);
      }, 50);
    }
  }, [gridFocus]);

  //#region  Button Event
  useImperativeHandle(ref, () => ({
    onSearch,
    onInsert,
    onDelete,
    onSave,
  }));
  //#endregion

  //#region OnSearch
  const onSearch = async () => {
    const modifiedRowsH = treeGridApiRef.current.getChange();
    if (modifiedRowsH.modifiedRowcount > 0) {
      const confirm = await showDialog(
        "confirmCancel",
        "수정된 내용이 있습니다. 저장하시겠습니까?"
      );
      if (confirm) {
        const isSaved: any = await onSave();
        if (!isSaved) {
          return;
        }
      } else if (confirm === undefined) {
        return;
      }
    }
    try {
      const params = {
        id: "sn_sys_bas_reg_001_01",
        params: searchRef.current.getFormdata(),
      };

      setFocusedRowData(null);
      setDataSource1([]);
      const data: any = await fnGetDataSet(params);

      const transformedData = (() => {
        // `cd_dept`를 키로, 항목을 값으로 하는 Map 생성
        const menuMap = new Map(
          data[0].map((item: any) => [item.cd_menu, item])
        );

        return data[0].map((item: any) => {
          const path_arr = [];
          let currentItem = item;

          while (currentItem) {
            path_arr.unshift(currentItem.cd_menu);
            currentItem = menuMap.get(currentItem.cd_menu_parent);
          }
          return {
            ...item,
            path_arr,
          };
        });
      })();
      // setDataSource1(data[0]);
      setDataSource1(transformedData);
      await new Promise((resolve) => setTimeout(resolve, 30));
      treeGridApiRef.current.api.refreshCells({
        columns: ["nm_menu"],
        force: true,
      });
      if (data[0] && data[0].length > 0) {
        await new Promise((resolve) => setTimeout(resolve, 50));
        setGridFocus(true);
      }

      treeGridApiRef.current.resetUpdate();

      setExpandBtnText("Expand");
      setIsExpanded(false);
    } catch (error: any) {}
  };
  //#endregion

  //#region onInsert
  const onInsert = async () => {
    const selectedRows = treeGridApiRef.current.api.getSelectedNodes();
    if (selectedRows.length === 0) return;
    try {
      const newRow = {}; // 빈 객체
      treeGridApiRef.current?.addRow(newRow);
    } catch (error: any) {}
  };
  //#endregion

  const onBeforeAddRow = (newRow: RowData): boolean => {
    try {
      const allRowData: any[] = [];
      treeGridApiRef.current.api.forEachNode((node: any) => {
        allRowData.push(node.data);
      });
      const selectedRows = treeGridApiRef.current.api.getSelectedNodes();
      const selectedNode = selectedRows[0];

      if (!selectedNode.expanded) {
        selectedNode.setExpanded(true); // 선택한 노드 확장
        selectedNode.group = true;
        treeGridApiRef.current.api.onGroupExpandedOrCollapsed(); // 확장 상태를 반영
      }

      const parentNode = selectedRows[0];
      const cd_menu_p = parentNode.data?.cd_menu;
      const nm_menu_p = parentNode.data?.nm_menu;
      const cd_module_p = parentNode.data?.cd_module;
      const yn_exc_p = parentNode.data?.yn_exc;
      const no_level_p = parentNode.data?.no_level;
      const selectedNodeChildren = parentNode.childrenAfterGroup || [];
      const seq = selectedNodeChildren.length + 1;
      const pos = "00" + seq.toString();
      const no_pos = parentNode.data?.no_pos + pos.substring(pos.length - 3);

      const updatedRow = {
        cd_menu_parent: cd_menu_p,
        nm_menu_parent: nm_menu_p,
        cd_module: cd_module_p,
        yn_exc: yn_exc_p,
        no_level: no_level_p + 1,
        no_pos: no_pos,
        no_seq: seq,
        no_mgmt: "",
        cd_menu: "",
        nm_menu: "",
        nm_menu_origin: "",
        nm_window: "",
        nm_file: "",
        nm_enmenu: "",
        nm_cnmenu: "",
        nm_jpmenu: "",
        nm_vnmenu: "",
        fg_menu: "",
        nm_cust_exc: "",
        path_arr: [
          ...(selectedRows[0].data?.path_arr || []), // 부모의 path_arr를 복사
          // `temp-${maxNoLine + 1}`, // 새로운 child 값을 추가
          `temp`,
        ],
      };

      Object.assign(newRow, updatedRow);

      return true;
    } catch (error: any) {
      return false;
    }
  };

  //#region onDelete
  const onDelete = async () => {
    try {
      treeGridApiRef.current?.deleteSelectedRows();
    } catch (error: any) {
      showDialog("error", error.message);
    }
  };
  //#endregion

  //#region onSave
  const onSave = async () => {
    try {
      const requiredValuesCheckL = treeGridApiRef.current.requiredValuesCheck();
      if (!requiredValuesCheckL) return;

      const changesRow = treeGridApiRef.current.getChange();
      const allRows = [
        ...(changesRow.insert ?? []),
        ...(changesRow.update ?? []),
      ];

      const requiredFields: { [key: string]: string } = {
        cd_menu: "메뉴코드는 필수값입니다.",
        nm_menu_origin: "원메뉴명은 필수값입니다.",
        nm_menu: "메뉴명은 필수값입니다.",
        cd_module: "모듈명은 필수값입니다.",
        fg_menu: "메뉴구분은 필수값입니다.",
        no_level: "메뉴레벨은 필수값입니다.",
        no_seq: "메뉴순서는 필수값입니다.",
        yn_exc: "전용여부는 필수값입니다.",
      };

      for (let i = 0; i < allRows.length; i++) {
        const row = allRows[i];
        for (const [key, message] of Object.entries(requiredFields)) {
          if (
            row[key] === undefined ||
            row[key] === null ||
            String(row[key]).trim() === ""
          ) {
            await showDialog("alter", `${message}`);
            return;
          }
        }
      }

      if ((changesRow.modifiedRowcount || 0) === 0) {
        await showDialog("alert", "변경된 내용이 없습니다.");
        return;
      }

      const SaveData = {
        sys_mmenu: changesRow,
      };
      if (changesRow.modifiedRowcount === 0) {
        await showDialog("alter", "변경된 내용이 없습니다.");
        return;
      }
      await fnSave("SN_SYS_BAS_REG_001_SAVE_01", SaveData);

      treeGridApiRef.current.resetUpdate();

      return true;
    } catch (error: any) {}
  };
  //#endregion

  //#region onFocusedRowChanged
  const onFocusedRowChanged = useCallback(
    (focusedRowData: any | null) => {
      setFocusedRowData(focusedRowData);
    },
    [focusedRowData]
  );
  //#endregion

  //#region onGridBtnsClick
  const onGrid1BtnsClick = async (id: string) => {
    try {
      const rowCount = treeGridApiRef.current?.api?.getDisplayedRowCount?.();

      if (!rowCount || rowCount === 0) {
        return;
      }
      if (isExpanded) {
        treeGridApiRef.current.api.collapseAll();
      } else {
        treeGridApiRef.current.api.expandAll();
      }
      setExpandBtnText(!isExpanded ? "Collapse" : "Expand");
      setIsExpanded(!isExpanded);
    } catch (error) {}
  };

  //#region onValueChanged
  const onValueChaged = async (data: any, param: string, formData: any) => {
    switch (param) {
      case "cd_module":
        if (data !== "XTC" || data !== "G2I") {
          return { nm_cust_exc: "" };
        }
        return;

      case "fg_menu":
        setAutogroupDef(autoGroupColumnDef);
        break;

      default:
        return {};
    }
  };

  const autoGroupColumnDef = {
    headerName: "메뉴명", // 그룹 컬럼의 헤더 이름
    field: "nm_menu", // 데이터를 표시할 필드
    flex: 1,
    filter: "agTextColumnFilter",
    cellClass: "large-cell", // add custom class
    cellRendererParams: {
      suppressCount: true,
      suppressDoubleClickExpand: true,
      suppressHoverHighlight: false,
      innerRenderer: (params: any) => {
        const { value, node } = params;

        let icon = "";
        if (node.data.fg_menu === "MGM" || node.data.fg_menu === "") {
          icon = node.expanded ? "📂" : "📁";
        } else if (node.data.fg_menu === "REG") {
          icon = "📝";
        } else if (node.data.fg_menu === "REP") {
          icon = "📄";
        }

        return `${icon} ${value}`;
      },
    },
    cellRenderer: "agGroupCellRenderer",
  };

  //#region UI
  return (
    <div className="h-full flex flex-col">
      <div className="mb-1">
        <SearchPanel
          ref={searchRef}
          data={formData}
          controls={formControlData}
          
        ></SearchPanel>
      </div>
      <div className="w-full flex h-full min-h-0 space-x-1.5">
        <SnResizable
          direction={"width"}
          seq={1}
          cd_menu={cd_menu}
          defaultSize={defaultSize}
          size={sizes.panel1}
          onResizeStop={onResizeStop}
          enable={{ right: true }}
          minWidth={130}
          minHeight={130}
        >
          <SnAgTree
            
            ref={treeGridApiRef}
            animateRows={false} // 애니메이션 비활성화
            rowData={dataSource1}
            columnConfig={columns}
            rowSelection="single"
            onFocusedRowChanged={onFocusedRowChanged}
            onBeforeAddRow={onBeforeAddRow}
            suppressNoRowsOverlay={true}
            autoGroupColumnDef={autoGroupColumnDef}
            headerHeight={50} // 헤더 안보이게
            getDataPath={(data) => data.path_arr}
            title="메뉴"
            enableAddRow={true}
            header={[
              <SnButton
                key="expand"
                text={expandBtnText}
                onClick={() => onGrid1BtnsClick("")}
              />,
            ]}
          />
        </SnResizable>
        <SnResizable
          direction={"width"}
          seq={2}
          cd_menu={cd_menu}
          defaultSize={defaultSize}
          size={sizes.panel2}
          onResizeStop={onResizeStop}
          enable={{ right: true }}
          minWidth={130}
          minHeight={130}
        >
          <SharedForm
            ref={SharedFormref1}
            data={focusedRowData}
            controls={sharedForm}
            gridref={treeGridApiRef}
            onValueChaged={onValueChaged}
            
            title="상세내용"
          ></SharedForm>
        </SnResizable>
      </div>
    </div>
  );
  //#endregion
});

export default SN_SYS_BAS_REG_001;
